import { SizeChart } from 'models/product';

type SizingChartTabProps = {
  charts: SizeChart[];
};

/** Renders the sizing chart(s) attached to the matching data depot product. */
export default function SizingChartTab({ charts }: SizingChartTabProps) {
  return (
    <div className="rounded-b-lg border border-zinc-300 p-8">
      <div className="flex flex-col gap-[4rem]">
        {charts.map((chart, chartIndex) => (
          <div key={chart.title || chartIndex} className="flex flex-col gap-4">
            {!!chart.title && (
              <h3 className="text-[2rem] font-semibold text-black">
                {chart.title}
              </h3>
            )}
            <div className="relative max-h-[40rem] w-full overflow-auto border-[1px] border-zinc-200">
              <table className="w-full">
                <thead>
                  <tr>
                    {chart.headers.map((header) => (
                      <th
                        key={header}
                        className="sticky top-0 whitespace-nowrap border-r border-[#D9D9D9] bg-[#222] p-6 text-left text-[1.8rem] font-semibold text-white"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {chart.rows.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-zinc-50'}
                    >
                      {chart.headers.map((header) => (
                        <td
                          key={header}
                          className="border-r border-t border-[#D9D9D9] p-6 text-left text-[1.8rem] text-black"
                        >
                          {row[header] ?? '-'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
